import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { FormGroupDirective, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HtmlRoutePages } from '~/app-routing.model';
import { MailApiService } from '~/core/api/mail-api/mail-api.service';
import { MetaPageEnum } from '~/core/declaration/declaration';
import { AssetService } from '~/core/services/assets/asset.service';
import { CounterService } from '~/core/services/counter/counter-service';
import { LocalesStateCountry, LocalesStateLang, LocalesStateLangList } from '~/core/store/locales/locales.model';
import { LocalesService } from '~/core/store/locales/locales.service';
import { SearchState } from '~/core/store/search/search.state';
import { MetaTagService } from '~/core/utils/global-utils/global-utils';
import { BreadcrumbserviceService } from '~/pages/breadcrumb/breadcrumbservice.service';
import { countries } from '../../../core/constants/country';
import { LocalesStateCountryList } from '../../../core/store/locales/locales.model';
@Component({
    selector: 'volvo-financing-page',
    templateUrl: './financing-page.component.html',
    styleUrls: ['./financing-page.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true }
        }
    ]
})
export class FinancingPageComponent implements OnInit {
    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild(FormGroupDirective) formDirective: FormGroupDirective;

    public sendStatus = false;
    private s0: Subscription;
    region: string;
    curLang: LocalesStateLangList;
    checkbox: string;
    reCaptchaRes: string;
    showRecaptcha: boolean = false;
    recaptchaToken: string;
    autoSelectCountry: LocalesStateCountryList;
    formOne = this.fb.group({
        companyName: ['', [Validators.required]],
        address: ['', [Validators.required]],
        country: ['', [Validators.required]]
    });

    noSpecialCharRegEx = /^[\p{L}\- \.\?!'\r\n,0-9\(\)]+$/u;

    formTwo = this.fb.group({
        fullName: ['', [Validators.required]],
        phone: ['', [Validators.pattern(/\d/g), Validators.required]],
        email: ['', [Validators.email, Validators.required]],
        message: ['', [Validators.pattern(this.noSpecialCharRegEx)]],
        privacy: [false, Validators.pattern('true')],
        token: ['']
    });

    dealershipCountries = countries;
    imageAltText: string = 'pages/services/images/financing/altimage1';

    constructor(
        private fb: UntypedFormBuilder,
        private http: HttpClient,
        private mailApiService: MailApiService,
        private sanitizer: DomSanitizer,
        public localesService: LocalesService,
        private titleService: Title,
        private metaTagService: MetaTagService,
        private translateService: TranslateService,
        private router: Router,
        private searchState: SearchState,
        private breadCrumbService: BreadcrumbserviceService,
        public assetService: AssetService,
        private localizeRouterService: LocalizeRouterService,
        private counterService: CounterService,
    ) {
        this.autoSelectCountry = this.searchState.getCurrentCountry();

        this.localesService.lang$.subscribe((lang: LocalesStateLang) => {
            this.curLang = lang.curLang;
            this.checkbox = '/' + this.curLang.id + '/privacy-policy';
        });
        this.recaptchaToken = environment.recaptchaSitekey;

        if (this.autoSelectCountry?.id === "za") {
            this.dealershipCountries = countries.filter(country => country.id === "za");
        } else { //hide request finance quote for Bosnia and Herzegovina
            this.dealershipCountries = countries.filter(country => country.id !== "za" && country.id !== "ba");
        }

        this.initSubscriptions();
    }

    ngOnInit(): void {
        this.router.events.subscribe(() => {
            this.metaTagService.updateTagFor(MetaPageEnum.FinancingPage);
        });
        this.metaTagService.updateTagFor(MetaPageEnum.FinancingPage);

    }

    resolved(captchaResponse: string, res) {
        this.reCaptchaRes = captchaResponse;
    }
    recaptcha() {
        this.showRecaptcha = !this.showRecaptcha;
    }

    async onSubmit(): Promise<void> {
        this.sendStatus = true;
        if (this.formOne.valid && this.formTwo.valid && this.reCaptchaRes) {
            const data = { ...this.formOne.value, ...this.formTwo.value };
            const body = this.transformDataForServer(data);
            const status = await this.mailApiService.postMailFinanceContact(body);
            this.sendStatus = false;


            if (status) {
                this.stepper.reset();
                this.formDirective.resetForm();
                this.showRecaptcha = false;
                this.reCaptchaRes = '';
            }

            window['dataLayer'] = window['dataLayer'] || [];
            window['dataLayer'].push({
                event: 'FormsubmittedFinancing'
            });
            //logging generic finance request
            this.counterService.postGenericFinanceRequest('Finance', 'Email', data.country, '');
        }
    }

    private transformDataForServer(data) {
        // TODO: ask someone to make nice API for this
        return {
            salesEmail: "", salesPersonName: "",
            dealershipcountry: data.country,
            name: this.sanitizer.sanitize(SecurityContext.HTML, data.fullName).trim(),
            email: data.email,
            phone: data.phone,
            message: this.sanitizer.sanitize(SecurityContext.HTML, data.message).trim(),
            token: this.reCaptchaRes,
            Address: data.address,
            CompanyName: data.companyName,
            privacy: data.privacy,
            region: this.region,
            site: "volvoselected"
        };
    }

    initSubscriptions() {
        this.s0 = this.localesService.region$.subscribe(results => {
            this.region = results.curRegion.id;
        })

        this.localesService.country$.subscribe((country: LocalesStateCountry) => {
            if (country && country.curCountry) {
                if (country.curCountry.id === 'ba') { //usecase: user is on financing page and from here country is changed to BiH then we need to hide financing and navigate to Volvo Selected page.
                    this.router.navigate([this.localizeRouterService.translateRoute(HtmlRoutePages.volvoSelected)]);
                }
            }
        });
    }
}
